import { LogoutOutlined } from "@ant-design/icons";
import { Layout, Menu } from "antd";

const { Header } = Layout;

const AdminHeader = (props) => {
  const { logOut, handleClick } = props;

  const handleMenuClick = ({ key }) => {
    if (key === "signout") logOut();
    else handleClick({ key });
  };
  return (
    <div className="header-wrapper">
      <Header>
        <Menu
          theme="light"
          mode="horizontal"
          onClick={handleMenuClick}
          style={{
            display: "flex",
            justifyContent: "end"
          }}
        >
          <Menu.Item key="signout">
            <LogoutOutlined />
            <span>登出</span>
          </Menu.Item>
        </Menu>
      </Header>
    </div>
  );
};

export default AdminHeader;
